<template>
  <v-dialog
    persistent
    :value="true"
    max-width="768px"
  >
    <v-card>
      <v-card-title>Смена временного пароля</v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="formValid" class="row">
            <v-col cols="12">
              <span>Вы вошли в личный кабинет с помощью временного пароля, его необходимо заменить.</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="currentPassword"
                hide-details
                dense
                label="Текущий пароль"
                required
                outlined
                prepend-inner-icon="mdi-lock-outline"
                :rules="[rule.required('')]"
                @change="$refs.form.validate()"
                @blur="$refs.form.validate()"
                type="password"
                name="current_password"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="newPassword"
                dense
                label="Новый пароль"
                required
                outlined
                prepend-inner-icon="mdi-lock-outline"
                :rules="[rule.required(''), rule.notRussian, rule.min, rule.upper, rule.lower, rule.digit]"
                :type="showSymbols ? 'text' : 'password'"
                @change="$refs.form.validate()"
                @blur="$refs.form.validate()"
                name="new_password"
              >
                <template #append>
                  {{ null }}
                  <v-icon v-show="showSymbols" @click="showSymbols = !showSymbols" tabindex="-1">mdi-eye</v-icon>
                  <v-icon v-show="!showSymbols" @click="showSymbols = !showSymbols" tabindex="-1">mdi-eye-off</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col v-if="!showSymbols" cols="12">
              <v-text-field
                ref="field_confirm"
                dense
                label="Подтвердите пароль"
                required
                outlined
                :rules="[v => v === this.newPassword || 'Пароли не совпадают']"
                prepend-inner-icon="mdi-lock-outline"
                type="password"
                name="confirm_password"
              >
              </v-text-field>
            </v-col>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!formValid" color="primary" elevation="0" @click="send">Изменить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "@/utils/rules";
import { changePass } from "@/api/user";

export default {
  name: "ChangePasswordModal",

  data: () => ({
    formValid: false,

    currentPassword: null,
    newPassword: null,
    showSymbols: false,

    rule: {
      required,

      min: (v) => v && v.length >= 6 || "Минимум 6 символов",
      notRussian: (v) => !/[А-Я]|[а-я]|\s/.test(v) || "Без пробелов и букв русского алфавита",
      upper: (v) => /[A-Z]/.test(v) || "Одна заглавная латинская буква",
      lower: (v) => /[a-z]/.test(v) || "Одна строчная латинская буква",
      digit: (v) => /\d/.test(v) || "Одна цифра",
    }
  }),

  watch: {
    showSymbols(v) {
      if (v) {
        this.$refs.field_confirm.reset();
      }
      this.$refs.form.validate();
    }
  },

  methods: {
    async send() {
      if (this.$refs.form.validate()) {
        const changePassResult = await changePass(this.currentPassword, this.newPassword);

        if (changePassResult) {
          this.$store.dispatch("profile/get");
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
